import { useEffect, useState, useCallback } from "react";
import { noop } from "shared/constants";
import { writeXLSFile } from 'utils';
import DownloadView from "./view";

let downloadTimer = null;
const defaultState = {
  downloadDialog: {
    open: false,
    progress: 0,
  },
};

const Download = ({
  isTemplateDownloaded = false,
  onTemplateDownload = noop
}) => {

  const [state, setState] = useState(defaultState);

  const handleDownloadTemplate = useCallback(() => {
    const sheetData = [
      { column: "Name", width: 24 },
      { column: "Site Name", width: 24 },
      { column: "Street", width: 24 },
      { column: "Street 2 (Apt./Unt.)", width: 24 },
      { column: "City", width: 24 },
      { column: "State", width: 24 },
      { column: "Zip", width: 24 },
      { column: "Country", width: 24 },
    ];
    const sheet = [
      {
        data: [sheetData.reduce((acc, item) => ({ ...acc, [item.column]: "" }), {})],
        columnConfig: [{
          type: '!cols',
          value: sheetData.map(({ width }) => ({ width })),
        }]
      }
    ];
    writeXLSFile(`donut-erl-template.xlsx`, sheet, {
      bookType: 'xlsx',
      raw: false,
    });
    onTemplateDownload();
  }, []);


  const handleDownlodDialogClose = (success = false) => {
    clearInterval(downloadTimer);
    setState(prevState => ({
      ...prevState,
      downloadDialog: {
        ...prevState.downloadDialog,
        open: false,
        progress: 0
      }
    }));
    success && handleDownloadTemplate()
  };

  useEffect(() => {
    if (state.downloadDialog.open) {
      clearInterval(downloadTimer);
      downloadTimer = setInterval(() => {
        setState(prevState => {
          if (prevState.downloadDialog.progress >= 100) {
            handleDownlodDialogClose(true);
          }
          return {
            ...prevState,
            downloadDialog: {
              ...prevState.downloadDialog,
              progress: prevState.downloadDialog.progress + 20
            }
          }
        });
      }, 300);
    }

    return () => {
      clearInterval(downloadTimer);
    };
  }, [state.downloadDialog.open]);

  return (
    <DownloadView
      isTemplateDownloaded={isTemplateDownloaded}
      downloadDialog={state.downloadDialog}
      handleDownlodDialogClose={() => handleDownlodDialogClose(false)}
      handleDownloadClick={() => {
        setState(prevState => ({
          ...prevState,
          downloadDialog: {
            open: true,
            progress: 0,
          }
        }))
      }}
    />
  )
};

export default Download;